export default __webpack_public_path__ + "static/logo_reversed_mono_mark-59574aeeb9454ae0dceb24ac088aa59b.svg";